// Copyright (c) Move Closer 2022.

// Copyright (c) Move Closer 2022.
/* eslint-disable */
export const messages = {}

const backupMessages = Object.assign({}, messages);

//export default messages;

function getCurrentMessageHandlers () {
  return messages;
}

function revertMessageHandlers () {
  Object.assign(messages, backupMessages)
}

function setMessageHandlers (newMessages) {
  Object.assign(messages, newMessages);
}

function setMessageHandler (rule, createMessage) {
  setMessageHandlers({
    [rule]: createMessage
  });
}

function getMessage (rule, fieldData) {
  if (messages[rule] === undefined) {
    return '';
  }
  return messages[rule](fieldData);
}

function getMessageHandler (rule) {
  return messages[rule];
}

export {
  setMessageHandlers,
  setMessageHandler,
  getMessage,
  getMessageHandler,
  revertMessageHandlers,
  getCurrentMessageHandlers
}
